import type { CSSProperties, ReactNode } from "react";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type SortableItemRenderProps = {
  setNodeRef: (node: HTMLElement | null) => void;
  attributes: ReturnType<typeof useSortable>["attributes"];
  listeners: ReturnType<typeof useSortable>["listeners"];
  style: CSSProperties;
  isDragging: boolean;
};

type SortableItemProps = {
  id: string;
  disabled?: boolean;
  children: (props: SortableItemRenderProps) => ReactNode;
};

/**
 * Generic render-prop wrapper around dnd-kit's `useSortable`
 */
const SortableItem = ({ id, disabled, children }: SortableItemProps) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <>{children({ setNodeRef, attributes, listeners, style, isDragging })}</>
  );
};

export default SortableItem;
